import {gql} from '@apollo/client';

export const FetchFinanceFeatures = gql`
    query FetchFinanceFeatures($institutionSetId: InstitutionSetId!) {
        finance {
            supports(institutionSetId: $institutionSetId) {
                canExportXero
                canExportSEPA
                canExportSage200
                canExportSageIntacct
                canExportDatev
                canExportOrgPublicFunding
                canUseAutomaticInvoicing
                canUseSimplifiedUsBillingPlan
                canUseSimplifiedUsEditBillingPlan
                canSendTaxStatementReadyEmails
                shouldAdjustInvoiceDate
                canManagePublicFundingSettings
                canExportInvoicePdfs
                canManagePlansForAttendance
                canManageMultiplePricingRuleGroups
                canConfigureTaxFreeChildcare
                canUseTaxFreeChildcare
                hasConnectedToTaxFreeChildcare
                canUsePlanRules
                canScheduleAPlanBreak
                chillBillEditInChildProfile
                canUseSubscriptionPageRedesign
                canUseAdditionalChargeRules
                kitabuli {
                    integrationIsEnabled
                    canAccessKitabuli
                    canManageKitabuliIntegration
                }
                purchases {
                    automaticPricing
                    canManagePurchasesWithAutomaticPricing
                    canUseNewPurchaseDesign
                }
                plans {
                    canManageSurcharges
                    canManageDiscounts
                    hasPreventDoubleBookings
                }
                ukFunding {
                    canManageFundingOnChildProfile
                    canManageNonFundableDays
                }
                canManageIsbjIntegration
                invoicing {
                    canUseAnnualizedV2
                }
            }
        }
    }
`;
